import { PATH_DASHBOARD } from '@/routes/paths'
import { CONFIG_TYPES, fulfillmentProviders } from '@/utils/enums/fulfillmentProviders'

export const isAmazonMCFProvider = (provider) =>
    provider?.type === fulfillmentProviders.amazon_mcf.type

export const isShippingEasyProvider = (provider) =>
    provider?.type === fulfillmentProviders.shippingeasy.type

export const isShipStationProvider = (provider) =>
    provider?.type === fulfillmentProviders.shipstation.type

export const isExtensivProvider = (provider) =>
    provider?.type === fulfillmentProviders.extensiv.type

export const isFulfillmentLab = (provider) =>
    provider?.type === fulfillmentProviders.fulfillment_lab.type

export const isManualFulfillmentProvider = (provider) =>
    provider?.type === fulfillmentProviders.manual_fulfillment.type

const fulfillmentProviderUrl = (type, providers = []) => {
    const provider = providers.find((p) => p.type === type)
    const { id = 'connect' } = provider || {}
    return `${PATH_DASHBOARD.settings.fulfillment.root}/${type}/${id}`
}

export const getAdditionalInfo = (provider) => {
    if (provider?.type === fulfillmentProviders.amazon_mcf.type) {
        return (
            provider?.configurations?.find((c) => c.key === CONFIG_TYPES.MARKETPLACE)?.value || ''
        )
    }

    return ''
}

export default fulfillmentProviderUrl
